import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';

const FIFTEEN_MIN = 15 * 60 * 1000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: FIFTEEN_MIN,
      gcTime: FIFTEEN_MIN + 60_000,
    },
  },
});

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>{children}</BrowserRouter>
      <Toaster
        richColors
        position="top-right"
        offset={8}
        toastOptions={{
          style: {
            padding: '10px',
            minHeight: 'auto',
          },
        }}
      />
    </QueryClientProvider>
  );
}
